angular.module('app').directive('apDatePicker',
    ['_', '$window',
        function (_, $window) {
            'use strict';

            //API: https://api.jqueryui.com/datepicker/   25 March 2015

            //uses:
            //<input type="text" ap-date-picker>    (appears after clicking in box)
            //<div ap-date-picker></div>            static calendar

            //getDay() --> returns the day of the week (0-6) sunday-saturday
            //getDate() --> July 21 returns 21
            //getFullYear() --> July 21 2015 returns 2015
            //getMonth() --> July 21 returns 6  (starts from 0)

            $window=$window;

            var calendar = {
                selectedDate: null
            };

            var calendarOptions = {
                disableWeekends: true,
                disablePastDates: true
            };

            var disabledDates = {
                year: 2015,
                month: 3,
                days: [13,15,17,21]
            };

            var selectDate = function (date) {
                calendar.selectedDate=date;
                //$window.alert(calendar.selectedDate);
            };

            var setDisabledDates = function (year, month, days) {
                disabledDates.year=year;
                disabledDates.month=month;
                disabledDates.days=days;
            };

            var weekends = function (date) {
                var day = date.getDay();
                return (day > 0 && day < 6);
            };

            var isValidDay = function (date) {
                var enableDay = true;
                if(date.getMonth() === disabledDates.month && date.getFullYear() === disabledDates.year) {
                    enableDay = disabledDates.days.indexOf(date.getDate()) === -1;
                }
                if(enableDay && calendarOptions.disableWeekends) {
                    enableDay = weekends(date);
                }
                return [enableDay, ''];
            };

            //inst.selectedMonth  (month) goes from 0-11
            var calendarShow = function (input, inst) {
                //query server and set disabled dates
                //the calendar is first opened (no month set)
                if(inst.selectedDay === 0) {
                    var d = new Date();
                    d=d;
                    setDisabledDates(disabledDates.year, disabledDates.month, disabledDates.days);
                    //$window.alert(d.getDate());
                }
                else{
                    //$window.alert(month);
                }
            };

            //month goes from 1-12
            //inst.selectedMonth will be 0-11
            var monthChange = function (year ,month ,inst){
                inst=inst;
                //query server and set disabled dates
                //$window.alert(month);
            };

            return {
                restrict: 'A',
                link: function ($scope, elm) {
                    elm.datepicker({
                        changeYear: false,
                        minDate: calendarOptions.disablePastDates ? '0d' : '',
                        onChangeMonthYear: monthChange,
                        beforeShow: calendarShow,
                        beforeShowDay: isValidDay,
                        onSelect: selectDate
                    });
                    $scope.$on('destroy', function() {
                        elm.datepicker('destroy');
                    });
                }
            };
        }]);